export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Foshan · Premium Sourcing Atelier",
    title_line1: "Furnish your world,",
    title_accent: "sourced",
    title_suffix: " with intent.",
    subtitle:
      "From a single statement piece to an entire residence — we curate furniture, custom cabinetry and interiors from China's finest factories, and manage every step to your door.",
    primary_cta: "Explore the Store",
    secondary_cta: "Send Your Floor Plan",
    trusted_label: "Trusted by clients in",
    trusted_text: "United Kingdom · Australia · New Zealand · Singapore · UAE",
    image_url:
      "https://images.pexels.com/photos/33685861/pexels-photo-33685861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1300",
    image_caption: "Whole-home interiors · Foshan, China",
  },
  about: {
    eyebrow: "About Afurnix",
    title: "Not just a supplier — your",
    accent: "sourcing partner",
    title_suffix: " in China.",
    paragraph1:
      "Afurnix helps international clients source from trusted factories in Foshan — covering furniture, kitchens, wardrobes, lighting, curtains, carpets and selected interior materials.",
    paragraph2:
      "Our role is to help you make better sourcing decisions: from requirement matching and quotations to customization, factory coordination, inspections and shipping. Professional, transparent, efficient.",
    cta_label: "Read more about us",
    image1: "https://images.unsplash.com/photo-1554995207-c18c203602cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    image2: "https://images.pexels.com/photos/18285887/pexels-photo-18285887.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  },
  why: {
    eyebrow: "Why Afurnix",
    title: "One partner for the",
    accent: "entire journey.",
    description: "Sourcing from China offers better variety and stronger value — but only when the process is managed properly.",
    items: [
      { title: "Whole-Home Sourcing", description: "Furniture, custom cabinetry, lighting, curtains, carpets and selected interior materials — coordinated as one." },
      { title: "Coordination Across Categories", description: "Instead of chasing multiple suppliers, we align products, finishes, dimensions and style direction across your project." },
      { title: "Remote or In-Person Support", description: "Visit Foshan or buy remotely — curated selections, video calls and ongoing coordination throughout." },
      { title: "Clarity, Not Trial & Error", description: "From quotations to pre-shipment checks, we reduce confusion and sharpen every decision you make." },
    ],
  },
  who: {
    eyebrow: "Who We Work With",
    title: "Trusted by people who",
    accent: "value the detail.",
    items: [
      { title: "Homeowners", description: "For villas, penthouses and full-home furnishing projects that deserve a considered, end-to-end approach." },
      { title: "Interior Designers", description: "For studios who need reliable sourcing, customization and execution support on the ground in China." },
      { title: "Developers & Hospitality", description: "For high-end apartments, hotels, offices and commercial interiors requiring coordinated sourcing at scale." },
    ],
  },
  process: {
    eyebrow: "Our Process",
    title: "From floor plan",
    accent: "to delivery.",
    description: "A simple, structured path for whole-home sourcing, custom cabinetry and international delivery.",
    steps: [
      { title: "Share Your Project", description: "Send your floor plan, style references, cabinetry requirements, product list and budget." },
      { title: "Matching & Quotation", description: "We recommend suitable products, factories and customization options based on your needs." },
      { title: "Confirmation & Production", description: "Once selections are confirmed, we coordinate specifications, finishes and production." },
      { title: "Inspection & Quality Check", description: "Before shipment, we review product details and coordinate checking procedures." },
      { title: "Shipping & Delivery", description: "We assist with shipping coordination, export handling and delivery planning to your destination." },
    ],
  },
  advantages: {
    eyebrow: "Our Advantages",
    title: "Built on craft &",
    accent: "conscience.",
    items: [
      { title: "Concierge-Level Excellence", description: "Beyond sourcing — visa assistance, travel planning, hotel reservations and curated dining for visiting clients. White-glove from first call to final delivery." },
      { title: "Strategic Foshan Advantage", description: "At the heart of China's furniture ecosystem, with access to over 3,000 factories and the world's largest furniture wholesale market." },
      { title: "Quality Without Compromise", description: "Every supplier is rigorously vetted against international certification standards, so your investment delivers lasting value." },
      { title: "Social Responsibility", description: "We donate 5% of profits to global causes — education, healthcare, disaster relief and community development. Choosing Afurnix creates positive impact." },
    ],
  },
  faq: {
    eyebrow: "FAQ",
    title: "Good to",
    accent: "know.",
    items: [
      { q: "Do you only provide furniture?", a: "No. We source whole-home interiors — furniture, custom cabinetry, kitchens, wardrobes, lighting, curtains, carpets and selected interior materials." },
      { q: "Can I buy without visiting China?", a: "Absolutely. Most of our international clients buy remotely. We support you with curated selections, video factory walkthroughs and ongoing coordination." },
      { q: "Do you offer custom cabinets and wardrobes?", a: "Yes. Bespoke cabinetry and wardrobes are a core service — made to your drawings, finishes and dimensions, then inspected before shipping." },
      { q: "What do you need for a quotation?", a: "Share your floor plan, style references, a product or cabinetry list, and a rough budget. The more detail, the sharper the quotation." },
      { q: "Do you help with shipping?", a: "Yes. We assist with export coordination, consolidation, shipping and delivery planning to your destination." },
      { q: "Who do you usually work with?", a: "Homeowners furnishing villas and penthouses, interior designers needing reliable execution, and developers or hospitality teams running larger projects." },
    ],
  },
  cta: {
    eyebrow: "Begin Your Project",
    title: "Source with more clarity,",
    accent: "stronger results.",
    subtitle: "Send us your floor plan and product list. Our team will return a tailored sourcing plan and quotation.",
    button: "Send Your Floor Plan",
    image_url: "https://images.pexels.com/photos/37110043/pexels-photo-37110043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  },
  about_page: {
    header_eyebrow: "About Afurnix",
    header_title: "Sourcing, with",
    header_accent: "intention.",
    header_description:
      "We help international clients source premium furniture, custom cabinetry and interiors from China — professionally, transparently and efficiently.",
    intro_heading: "Based in Foshan, the heart of China's furniture ecosystem.",
    intro_paragraph1:
      "Afurnix is a sourcing partner for premium furniture, custom cabinetry and interiors. We cover furniture, kitchens, wardrobes, lighting, curtains, carpets and selected interior materials — sourced from trusted factories and delivered to clients around the world.",
    intro_paragraph2:
      "We don't just help clients buy products; we help them make better sourcing decisions throughout the process — from requirement matching and quotations to customization, factory coordination, inspections and shipping support.",
    intro_image: "https://images.pexels.com/photos/33685861/pexels-photo-33685861.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
    promise_eyebrow: "Our Promise",
    promise_title: "Clarity, quality control,",
    promise_accent: "and service.",
    promise_description:
      "Transparent process and quotation support before production. Pre-shipment inspections to reduce avoidable mistakes. Global delivery support from factory to your destination.",
    promise_button: "Work With Us",
  },
  services_page: {
    header_eyebrow: "Services & Contract",
    header_title: "A complete sourcing",
    header_accent: "service.",
    header_description:
      "From a single piece to a multi-unit development — Afurnix manages the entire journey, so you can focus on the design.",
    items: [
      { title: "Whole-Home Sourcing", description: "End-to-end sourcing of furniture, cabinetry, lighting and soft furnishings, coordinated to a single design direction." },
      { title: "Custom Cabinetry & Joinery", description: "Bespoke kitchens, wardrobes and built-ins made to your drawings, finishes and millimetre tolerances." },
      { title: "Quotation & Matching", description: "We match the right products and factories to your brief, with transparent, itemised quotations." },
      { title: "Quality Control & Inspection", description: "Pre-shipment inspections coordinated at the factory, with photo and video reporting before goods leave." },
      { title: "Logistics & Delivery", description: "Consolidation, export handling, shipping and delivery planning to your destination port or door." },
      { title: "Trade & Contract Programmes", description: "Volume sourcing for designers, developers and hospitality, with staged delivery aligned to your programme." },
    ],
    trade_eyebrow: "For Trade & Developers",
    trade_title: "Source at scale,",
    trade_accent: "without the chaos.",
    trade_description:
      "One accountable partner across every supplier — aligned finishes, consistent quality and staged delivery for projects of any size.",
    trade_button: "Enquire About Contract Sourcing",
  },
  contact_page: {
    header_eyebrow: "Contact",
    header_title: "Send your floor",
    header_accent: "plan.",
    header_description:
      "Tell us about your project — floor plan, product list, style references and budget. Our team replies within one business day.",
    based_in: "Foshan, China",
    email: "hello@afurnix.com",
    whatsapp_label: "Chat with our team →",
  },
};
